import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import useSingleProduct from "../../../../../hooks/useSingleProduct";

const ProductEdit = () => {
  const { id } = useParams();
  const [viewProduct] = useSingleProduct(id);
  const [validated, setValidated] = useState(false);
  const toastId = React.useRef(null);

  //   handle load in a form
  //   const {
  //     email,
  //     photoURL,
  //     productCategory,
  //     productDescription,
  //     productName,
  //     productPrice,
  //     productQuantity,
  //   } = viewProduct.data;

  const [viewProductName, setViewProductName] = useState("");
  const [viewProductPrice, setViewProductPrice] = useState("");
  const [viewProductQuantity, setViewProductQuantity] = useState("");
  const [viewPhotoURL, setViewPhotoURL] = useState("");
  const [viewProductDescription, setViewProductDescription] = useState("");
  const [viewProductCategory, setViewProductCategory] = useState("");
  useEffect(() => {
    setViewProductName(viewProduct?.data?.productName);
    setViewProductPrice(viewProduct?.data?.productPrice);
    setViewProductQuantity(viewProduct?.data?.productQuantity);
    setViewPhotoURL(viewProduct?.data?.photoURL);
    setViewProductCategory(viewProduct?.data?.productCategory);
    setViewProductDescription(viewProduct?.data?.productDescription);
  }, [viewProduct]);

  //   const handleToChange = (event, setValue) => {
  //     setValue(event.target.value);
  //     console.log(event.target.value);
  //   };

  const handleChangeProductName = (e) => {
    setViewProductName(e.target.value);
  };
  const handleChangeProductPrice = (e) => {
    setViewProductPrice(e.target.value);
  };
  const handleChangeProductQuantity = (e) => {
    setViewProductQuantity(e.target.value);
  };
  const handleChangePhotoURL = (e) => {
    setViewPhotoURL(e.target.value);
  };
  const handleChangeProductCategory = (e) => {
    setViewProductCategory(e.target.value);
  };
  const handleChangeProductDescription = (e) => {
    setViewProductDescription(e.target.value);
  };
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (form.checkValidity() === true) {
      const productName = event.target.productName.value;
      const productPrice = event.target.productPrice.value;
      const productQuantity = event.target.productQuantity.value;
      const photoURL = event.target.photoURL.value;
      const productCategory = event.target.productCategory.value;
      const productDescription = event.target.productDescription.value;
      const updateProductInfo = {
        productName,
        productCategory,
        productPrice,
        photoURL,
        productQuantity,
        productDescription,
      };
      const notify = () =>
        (toastId.current = toast("Updating", { autoClose: true }));
      const update = () =>
        toast.update(toastId.current, {
          render: "Successfully Update",
          type: toast.TYPE.SUCCESS,
          autoClose: 1000,
        });
      const url = `https://rocky-ravine-79485.herokuapp.com/product/edit/${id}`;

      axios.put(url, updateProductInfo).then((res) => {
        const resSuccess = res.status;
        notify();
        if (resSuccess === 200) {
          // const form = document.getElementById("addProduct");
          update();
          form.reset();
        }
      });
    }

    setValidated(true);
  };

  return (
    <>
      <Container>
        <Row>
          {/* <MyEditor></MyEditor> */}
          <Col md={12}>
            <h1 className="text-center my-4">Update Your Product</h1>
            <hr />
            <br />
            <Form
              id="addProduct"
              noValidate
              validated={validated}
              onSubmit={handleSubmit}
            >
              <Row className="mb-3">
                <Form.Group
                  as={Col}
                  className="my-3"
                  md="10"
                  controlid="validationCustom01"
                >
                  <Form.Label>Product Name</Form.Label>
                  <Form.Control
                    value={viewProductName}
                    name="productName"
                    required
                    type="text"
                    placeholder="Product Name"
                    onChange={handleChangeProductName}
                  />
                </Form.Group>

                <Form.Group as={Col} md="4" controlid="validationCustom02">
                  <Form.Label>Price</Form.Label>{" "}
                  <InputGroup
                    className="mb-3"
                    as={Col}
                    md="4"
                    controlid="price"
                  >
                    <InputGroup.Text>$</InputGroup.Text>
                    <Form.Control
                      required
                      type="number"
                      name="productPrice"
                      value={viewProductPrice}
                      onChange={handleChangeProductPrice}
                    />
                  </InputGroup>
                </Form.Group>
                <Form.Group as={Col} md="4" controlid="validationCustom02">
                  <Form.Label>Quantity</Form.Label>{" "}
                  <InputGroup
                    className="mb-3"
                    as={Col}
                    md="4"
                    controlid="price"
                  >
                    <Form.Control
                      name="productQuantity"
                      required
                      type="number"
                      value={viewProductQuantity}
                      onChange={handleChangeProductQuantity}
                    />
                  </InputGroup>
                </Form.Group>
                <Form.Group
                  as={Col}
                  md="10"
                  controlid="validationCustomUsername"
                >
                  <Form.Label>Photo URL</Form.Label>
                  <InputGroup hasValidation>
                    <InputGroup.Text id="inputGroupPrepend">
                      <svg
                        width={15}
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                        />
                      </svg>
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="photoURL"
                      placeholder="Please Input A Valid Image URL"
                      aria-describedby="inputGroupPrepend"
                      required
                      value={viewPhotoURL}
                      onChange={handleChangePhotoURL}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please input a valid URL.
                    </Form.Control.Feedback>
                  </InputGroup>
                  <img
                    style={{
                      width: "150px",
                      height: "200px",
                      objectFit: "contain",
                    }}
                    className=" img-fluid mt-3"
                    src={viewPhotoURL}
                    alt="Invalid Url"
                  />
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md="4" controlid="validationSelect">
                  <Form.Label>Category</Form.Label>
                  <Form.Select
                    aria-label="Select A Category"
                    name="productCategory"
                    defaultValue="1"
                  >
                    <option
                      value={viewProductCategory}
                      onChange={handleChangeProductCategory}
                      disabled
                    >
                      Select A Category
                    </option>
                    <option value="fruit">Fruit</option>
                    <option value="dairy">Dairy</option>
                    <option value="Fish">Meet</option>
                  </Form.Select>
                </Form.Group>
              </Row>
              <Row>
                <Col md={8} className="mb-4">
                  <Form.Group
                    // className="mb-3"
                    controlid="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      value={viewProductDescription}
                      onChange={handleChangeProductDescription}
                      name="productDescription"
                      as="textarea"
                      rows={4}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Button variant="success" type="submit">
                Update Product
              </Button>
            </Form>
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ProductEdit;
